import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from '../../../../../shared/router/useNavigate';
import { useNewBookingStore } from '../../../../domain/booking/stores/useNewBookingsStore';
import { IParkingProduct } from '../../../../domain/parking-product/models/IParkingProduct';
import { trackRemoveProduct } from '../../shared/analytics/e-commerce/trackRemoveProduct';
import { trackSelectProduct } from '../../shared/analytics/e-commerce/trackSelectProduct';

interface IOptions {
	extrasUrl: string;
	fallbackUrl: string;
}

export function useSelectProduct({ extrasUrl, fallbackUrl }: IOptions) {
	const newBookingStore = useNewBookingStore();
	const [hasSelectedProduct, setHasSelectedProduct] = useState(false);
	const navigate = useNavigate();

	const {
		hasFinishedLoadingUpgrades,
		hasFinishedLoadingAncillaries,
		hasUpgrades,
		hasAncillaries,
		error,
	} = newBookingStore.parkingProductsQuoteStore;

	const onSelectProduct = useCallback(
		(selectedParkingProduct: IParkingProduct) => {
			if (newBookingStore.booking.parkingProduct) {
				trackRemoveProduct(newBookingStore.booking.parkingProduct);
			}

			newBookingStore.selectParkingProduct(selectedParkingProduct);
			setHasSelectedProduct(true);

			trackSelectProduct(selectedParkingProduct);
		},
		[newBookingStore],
	);

	const shouldNavigate =
		hasSelectedProduct &&
		hasFinishedLoadingUpgrades &&
		hasFinishedLoadingAncillaries &&
		!error;

	const shouldNavigateToExtrasPage = hasUpgrades || hasAncillaries;

	// Wait for optional upgrades and/or ancillaries to be fetched, either redirect to 'extras' or fallback page next
	useEffect(() => {
		if (!shouldNavigate) {
			return;
		}

		if (shouldNavigateToExtrasPage) {
			navigate(extrasUrl);
		} else {
			navigate(fallbackUrl);
		}
	}, [shouldNavigate, shouldNavigateToExtrasPage]);

	return { onSelectProduct, hasSelectedProduct };
}
